import { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import Text from '../Typography'

const InputLabel = styled(Text)`
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ isError, isFocus, theme }) =>
    isError
      ? theme.colors.red
      : isFocus
      ? theme.colors.kb5
      : theme.colors.textPrimary};
`

const StyledInput = styled.input`
  padding: 2rem;
  border: 1px solid black;
  border-radius: ${({ roundedCorners }) => (roundedCorners ? '6px' : '')};
  height: 7.2rem;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  width: 100%;
  color: #838383;
  ::placeholder {
    color: #838383;
    font-size: 1.4rem;
    font-weight: 500;
    text-transform: capitalize;
  }
`

export const TextArea = styled.textarea`
  padding: 1.7rem;
  border: 1px solid black;
  border-radius: 6px;
  resize: none;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  width: 100%;
  text-transform: capitalize;
  font-family: 'Poppins';
  color: #838383;
  height: ${({ height }) => height || '8.9rem'};
  ::placeholder {
    color: #838383;
    font-size: 1.4rem;
    font-weight: 500;
  }
`

export const Input = ({
  id,
  label,
  name,
  value,
  type = 'text',
  placeholder = '',
  hint,
  isError,
  error,
  disabled,
  cbHandler,
  roundedCorners,
  ...props
}) => {
  const [isFocus, setIsFocus] = useState(false)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    if (isError || error) setHasError(true)
    else setHasError(false)
  }, [error, isError])

  const changeHandler = useCallback(
    e => {
      e.preventDefault()
      if (cbHandler)
        cbHandler({
          name: e.target.name,
          value: e.target.value
        })
    },
    [cbHandler]
  )

  const focusHandler = useCallback(state => {
    setIsFocus(state)
  }, [])

  return (
    <>
      {label && (
        <InputLabel font="body2Medium" isFocus={isFocus} isError={hasError}>
          {label}
        </InputLabel>
      )}
      <StyledInput
        id={id}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        isError={hasError}
        disabled={disabled}
        {...props}
        onMouseDown={() => focusHandler(true)}
        onBlur={() => focusHandler(false)}
        onChange={changeHandler}
        roundedCorners={roundedCorners}
      />
    </>
  )
}
